
import Bunyan from 'bunyan';
const  log = Bunyan.createLogger({name: "Stack"});

import { STACK, NONE } from '../constants/types';
import Collection from './collection';

class Stack extends Collection { 

  TYPE = STACK;

  _add(value, _value) { 
    value.push(_value);
    return value;
  }

  _next(value) { 
    const nextValue = value.pop();
    return { nextValue, value };
  }

}

export default Stack;